import Api from './api'
import { getServiceUrlBases, makeIsInternalDomain } from './api/utils'

export default Api

export type { ApiConfig, ConfigGenerator, ApiConstructorParams } from './api/types'
export { HTTP_METHOD } from './api/types'
export { getServiceUrlBases, makeIsInternalDomain }
